<template>
    <ExpandBox
      :chevronIcon="chevronIcon"
      :title="$t('Add Extra Field')"
      @expanded="onExpanded"
    >

      <template v-slot:body>
            <TextField
              class="m1"
              id="field_name"
              :placeholder="'Field Name'"
              :label="$dft.capHead($t('field_name'))"
              :value="extra_field.field_name"
              :disabled="false"
              @valuechanged="onTextFieldValueChange"
              lw="0px"
              :bb="'none'"
              
            />
            <!-- <TextField
                
                id="data_type"
                :placeholder="'Data Type'"
                :label="$dft.capHead($t('data_type'))"
                :value="extra_field.data_type"
                :disabled="false"
                @valuechanged="onTextFieldValueChange"
                lw="0px"
                :bb="'none'"
            /> -->

            <Dropdown
              :id="'data_type'"
              class="m2"
              :options="dataTypeTV"
              :selected="dataTypeTV.find((e) => e.value == extra_field.data_type)"
              :placeholder="'Data Type'"
              box
              style="margin-top:10px;"
              @selectedChange="
                (e) => onDropdownChange('data_type', e)
              "
            />
            <button style="margin-left:0px;" @click="onAdd" class="dt-button v5">Add Extra Field</button>

      </template>
    </ExpandBox>
</template>
  
  <script>
 import ExpandBox from "@plugins/expandable-box/expand-box"; 
  
  export default {
    components: {
      ExpandBox
    },
    props: {
      
    },
    data: function() {
      return {
        extra_field:{
            field_name:'',
            data_type:''
        },

        dataTypeTV:[
          { text:'Decimal' , value:'decimal' },
          { text:'Text' , value:'text' },
          { text:'Email' , value:'email' },
          { text:'Check Box' , value:'check_box' },
          { text:'Date' , value:'date' },
          { text:'Number' , value:'int' },
          { text:'Text Box ' , value:'text_box' },

        ],
        expand: false,
        chevronIcon: true,
        expanded: "",
      };
    },
    mounted: function() {
  
    },
    computed: {

    },
    methods: {
      onTextFieldValueChange: function(id, value) {

        //this.$emit("changed", payload);
        console.log(id, value,":::::::::::::",this.extra_field)
        this.extra_field[id]=value;

      },
      onDropdownChange:function(name, e){
        this.extra_field[name]=e.value;
      },

      onExpanded: function (e) {
      // console.log("dddddd ", e);
        this.expanded = e;
      },
      onAdd:function(){

        this.expand=false;

        const payload = {
          field_name:this.extra_field.field_name,
            data_type:this.extra_field.data_type
        }
        this.$emit("onAdd",payload)
        this.extra_field.field_name='';
        this.extra_field.data_type='';
      }
    }
  };
  
  
  </script>
  
  <style lang="scss">
  .cmp-task-settings-extra-field {

  }
  </style>